import { TheWestSection } from '@news-mono/common'
import {
    AddToCartEvent,
    BreachEvent,
    BreachScreenContext,
    click_origin_breach_screen,
    DataLayerEventName,
    useFeature,
    useSubscribeWithGoogle,
} from '@news-mono/web-common'
import { TheWestSections } from '@west-australian-newspapers/publication-types'
import React, { useContext, useRef } from 'react'
import { useFeatureForSection } from '../../../../feature-toggling'
import { IconStar } from '../../../../icons/IconStar/IconStar'
import { useAuthActions } from '../../../../user-registration/authentication/AuthenticationProvider'
import { useSection, useSectionMetaInfo } from '../../../../__helpers'
import {getWeeklyPrice, ISubscriptionPackage } from '../../common'
import { createLinkClickEvent } from '../../createLinkClickHandler'
import BreachWallContent from '../BreachNotificationWrapper/BreachNotification/BreachWallContent/BreachWallContent'
import { ComputedPackageImage } from './ComputedPackageImage'
import {
    Ribbon,
    StyledPackageImage,
    StyledSubscribeWithGoogleButton,
    StyledSubscribeWithGoogleButton2022,
    StyledSubscriptionCancellationMessage,
    StyledSubscriptionPackage,
    StyledSubscriptionPackage2022,
    StyledSubscriptionPackageActions,
    StyledSubscriptionPackageButton,
    StyledSubscriptionPackageButton2022,
    StyledSubscriptionPackageHeading,
    StyledSubscriptionPackageHeading2022,
    StyledSubscriptionPackageOriginalPrice,
    StyledSubscriptionPackageOriginalPrice2022,
    StyledSubscriptionPackagePrice,
    StyledSubscriptionPackagePrice2022,
    StyledSubscriptionPackagePriceDivider2022,
    StyledSubscriptionPackagePriceQualifier,
} from './SubscriptionPackage.styled'
import { SubscriptionPackageBenefit } from './SubscriptionPackageBenefit'

const everyDayNewspaperImage = require('./images/updated2022/Weekend-Papers-plus-Everyday-Digita_Mobile.png')
const everyDayNewspaperImage2022x1 = require('./images/updated2022/redesign/mobile/everyday_digital_and_weekend_papers_cropped.png')
const everyDayNewspaperImage2022x2 = require('./images/updated2022/redesign/everyday_digital_and_weekend_papers_cropped.png')

const footyPackEverydayDigital = require('./images/footypack2023/everyday_digital.png')
const footyPackFriMonPrintDigital = require('./images/footypack2023/fri_mon_digital.png')

export interface SubscriptionPackageProps {
    breachCreativeName: string
    breachDeal: string
    packageInfo: ISubscriptionPackage
    masthead?: string
    packageTheme?: 'default' | 'red' | 'yellow'
    cancellationMessage?: string
    googleSKU?: string
    onEvent: (event: BreachEvent) => void
}

export const SubscriptionPackage: React.FC<SubscriptionPackageProps> = ({
    breachDeal,
    breachCreativeName,
    onEvent,
    masthead = 'The West Australian',
    packageInfo,
}) => {
    const {
        pretitle,
        heading,
        originalPrice,
        price,
        priceQualifier,
        ribbonTitle,
        packagePath,
        offerCode,
        packageTheme = 'default',
        packageType,
        cancellationMessage,
        googleSKU,
        weeklyPrice,
        weeklyDiscount,
        rateCode,
        benefitOverride
    } = packageInfo
    const { onSubscribeClick } = useAuthActions()
    const subscribeWithGoogleEnabled = useFeature('subscribe-with-google')
    const section = useSection<TheWestSection>()
    const isNewDesign = useFeatureForSection({
        feature: 'tp-subscription-new-breach-package-design',
        sections: TheWestSections.default,
    })

    const breachName = section === 'genwest' ? 'default' : section

    // Matches swg-breach-albany-advertiser etc
    const subscribeWithGoogleBreachInterfaceEnabled = useFeature(
        `swg-breach-${breachName}`,
    )

    const buttonRef = useRef<HTMLButtonElement>(null)

    const showSwG =
        subscribeWithGoogleEnabled &&
        subscribeWithGoogleBreachInterfaceEnabled &&
        googleSKU

    const sectionMeta = useSectionMetaInfo()

    const breachScreenContext = useContext(BreachScreenContext)
    const breachContext = breachScreenContext.context

    useSubscribeWithGoogle(
        buttonRef.current as HTMLButtonElement,
        googleSKU || 'everyday_digital_4weeks',
        sectionMeta,
        breachContext,
    )

    const addToCartPayload: AddToCartEvent['payload'] = {
        currency: 'AUD',
        item_id: rateCode,
        item_brand: masthead,
        item_name: heading,
        price: offerCode === undefined
            ? getWeeklyPrice(rateCode)
            : weeklyPrice,
        quantity: 1,
        coupon: offerCode,
        discount: weeklyDiscount ? weeklyDiscount : 0,
        item_variant: 'native',
    }
    if (isNewDesign) {
        const benefits = getBenefits(packageType,benefitOverride)
        return (
            <StyledSubscriptionPackage2022 packageTheme={packageTheme}>
                {packageType === 'digital' && breachDeal!=='AFL50' && (
                    <ComputedPackageImage
                        section={section}
                    ></ComputedPackageImage>
                )}

                {breachDeal==='AFL50' && packageType === 'digitalprint' &&
                    <StyledPackageImage
                        src={footyPackFriMonPrintDigital}
                        alt=""
                        role="presentation"
                    />
                }

                {breachDeal==='AFL50' && packageType == 'digital' &&
                    <StyledPackageImage
                        src={footyPackEverydayDigital}
                        alt=""
                        role="presentation"
                    />
                }

                {packageType === 'digitalprint' && breachDeal!=='AFL50' && (
                    <StyledPackageImage
                        src={everyDayNewspaperImage2022x1}
                        alt=""
                        role="presentation"
                        srcSet={`${everyDayNewspaperImage2022x1}, ${everyDayNewspaperImage2022x2} 2x`}
                    />
                )}

                {ribbonTitle && (
                    <Ribbon packageTheme={breachDeal==='AFL50' ? 'yellow' : packageTheme} className="newDesignTag">
                        <span>
                            <IconStar />
                            {ribbonTitle}
                        </span>
                    </Ribbon>
                )}

                <StyledSubscriptionPackageHeading2022>
                    {heading}
                </StyledSubscriptionPackageHeading2022>
                {originalPrice && (
                    <StyledSubscriptionPackageOriginalPrice2022
                        packageTheme={packageTheme}
                    >
                        {originalPrice}
                    </StyledSubscriptionPackageOriginalPrice2022>
                )}
                <StyledSubscriptionPackagePrice2022 packageTheme={packageTheme}>
                    {price}
                </StyledSubscriptionPackagePrice2022>
                {priceQualifier && (
                    <StyledSubscriptionPackagePriceQualifier
                        packageTheme={packageTheme}
                    >
                        {priceQualifier}
                    </StyledSubscriptionPackagePriceQualifier>
                )}
                <StyledSubscriptionPackagePriceDivider2022 />

                {benefits.map((benefit) => (
                    <SubscriptionPackageBenefit
                        benefit={benefit}
                        key={benefit.name}
                    />
                ))}

                <StyledSubscriptionPackageActions>
                    <StyledSubscriptionPackageButton2022
                        packageTheme={packageTheme}
                        buttonWidth="wide"
                        onClick={() => {
                            createLinkClickEvent(
                                breachCreativeName,
                                breachDeal,
                                onEvent,
                                undefined,
                                1,
                                addToCartPayload,
                            )()
                            onSubscribeClick({
                                packagePath,
                                offerCode,
                                callToAction: click_origin_breach_screen,
                            })
                        }}
                    >
                        Subscribe
                    </StyledSubscriptionPackageButton2022>

                    {packageType === 'digital' && showSwG && (
                        <StyledSubscribeWithGoogleButton2022
                            ref={buttonRef}
                            type="button"
                            onClick={() =>
                                onEvent({
                                    type: DataLayerEventName.addToCart,
                                    originator: 'breachscreen',
                                    payload: {
                                        currency: 'AUD',
                                        item_id: 'WST_DIGI_DD',
                                        item_brand: masthead,
                                        item_name: 'Everyday Digital',
                                        price: offerCode === undefined
                                            ? getWeeklyPrice(rateCode)
                                            : weeklyPrice,
                                        quantity: 1,
                                        discount: 0,
                                        item_variant: 'swg',
                                    },
                                })
                            }
                        />
                    )}

                    <StyledSubscriptionCancellationMessage
                        packageTheme={packageTheme}
                    >
                        {cancellationMessage}
                    </StyledSubscriptionCancellationMessage>

                </StyledSubscriptionPackageActions>
            </StyledSubscriptionPackage2022>
        )
    }

    return (
        // Note: There is high editorial care factor on these images, please ensure
        // appropriate approvals have happened before replacing or updating
        <StyledSubscriptionPackage packageTheme={packageTheme}>
            {packageType === 'digital' && breachDeal!=='AFL50' && (
                <ComputedPackageImage section={section}></ComputedPackageImage>
            )}

            {packageType === 'digitalprint' && breachDeal!=='AFL50' && (
                <StyledPackageImage
                    src={everyDayNewspaperImage}
                    alt=""
                    role="presentation"
                />
            )}

            {breachDeal==='AFL50' && packageType === 'digitalprint' &&
                <StyledPackageImage
                    src={footyPackFriMonPrintDigital}
                    alt=""
                    role="presentation"
                />
            }

            {breachDeal==='AFL50' && packageType == 'digital' &&
                <StyledPackageImage
                    src={footyPackEverydayDigital}
                    alt=""
                    role="presentation"
                />
            }

            <StyledSubscriptionPackageHeading packageTheme={packageTheme}>
                {heading}
            </StyledSubscriptionPackageHeading>
            {originalPrice && (
                <StyledSubscriptionPackageOriginalPrice
                    packageTheme={packageTheme}
                >
                    {originalPrice}
                </StyledSubscriptionPackageOriginalPrice>
            )}
            <StyledSubscriptionPackagePrice packageTheme={packageTheme}>
                {price}
            </StyledSubscriptionPackagePrice>
            {priceQualifier && (
                <StyledSubscriptionPackagePriceQualifier
                    packageTheme={packageTheme}
                >
                    {priceQualifier}
                </StyledSubscriptionPackagePriceQualifier>
            )}
            {ribbonTitle && (
                <Ribbon packageTheme={packageTheme}>
                    <span>
                        <IconStar />
                        {ribbonTitle}
                    </span>
                </Ribbon>
            )}
            <StyledSubscriptionPackageActions>
                <StyledSubscriptionPackageButton
                    packageTheme={packageTheme}
                    buttonWidth="wide"
                    onClick={() => {
                        createLinkClickEvent(
                            breachCreativeName,
                            breachDeal,
                            onEvent,
                            undefined,
                            1,
                            addToCartPayload,
                        )()
                        onSubscribeClick({
                            packagePath,
                            offerCode,
                            callToAction: click_origin_breach_screen,
                        })
                    }}
                >
                    Subscribe Now
                </StyledSubscriptionPackageButton>
                {packageType === 'digital' && showSwG && (
                    <StyledSubscribeWithGoogleButton
                        ref={buttonRef}
                        onClick={() =>
                            onEvent({
                                type: DataLayerEventName.addToCart,
                                originator: 'breachscreen',
                                payload: {
                                    currency: 'AUD',
                                    item_id: 'WST_DIGI_DD',
                                    item_brand: masthead,
                                    item_name: 'Everyday Digital',
                                    price: offerCode === undefined
                                        ? getWeeklyPrice(rateCode)
                                        : weeklyPrice,
                                    quantity: 1,
                                    discount: 0,
                                    item_variant: 'swg',
                                },
                            })
                        }
                    />
                )}

                <StyledSubscriptionCancellationMessage
                    packageTheme={packageTheme}
                >
                    {cancellationMessage}
                </StyledSubscriptionCancellationMessage>
            </StyledSubscriptionPackageActions>
        </StyledSubscriptionPackage>
    )
}

export const PACKAGE_BENEFIT_NAMES = [
    'Access to all digital content',
    'Weekend papers delivered',
    'Regional online news',
    'The West App',
    'Daily digital edition newspaper',
    'Subscriber rewards',
] as const

export type SubscriptionPackageBenefitValue = {
    name: typeof PACKAGE_BENEFIT_NAMES[number]
    isAvailable: boolean
}

export const getBenefits = (packageType?: string, customBenefit?: string[]) =>

    customBenefit?
    customBenefit.map((benefit) => ({
        name: benefit,
        isAvailable:
            benefit === 'Weekend papers delivered'
                ? packageType === 'digitalprint'
                : true
    })).sort((a, b) =>
        a.isAvailable === b.isAvailable
            ? 0
            : b.isAvailable > a.isAvailable
            ? 1
            : -1,
    )
    :
    PACKAGE_BENEFIT_NAMES.map((benefit) => ({
        name: benefit,
        isAvailable:
            benefit === 'Weekend papers delivered'
                ? packageType === 'digitalprint'
                : true
    })).sort((a, b) =>
        a.isAvailable === b.isAvailable
            ? 0
            : b.isAvailable > a.isAvailable
            ? 1
            : -1,
    )

SubscriptionPackage.displayName = 'SubscriptionPackage'

export default SubscriptionPackage
